import { illustrationLibrary, IllustrationName } from './illustration.helper';
import Svg from 'react-native-svg';

export type IllustrationProps = {
  name: IllustrationName;
  filled?: boolean;
  width?: number | string;
  height?: number | string;
  ref?: React.ForwardedRef<Svg>;
  testID?: string;
};

export const Illustration = (props: IllustrationProps) => {
  const SelectedIllustration = illustrationLibrary[props.name];
  return <SelectedIllustration {...props} />;
};
